var map = {
	"./About.vue": "r9dy",
	"./ArtworkGuidelines.vue": "NIcx",
	"./Blank.vue": "rMmh",
	"./BusinessCardsNew.vue": "+eQK",
	"./ChooseDesign.vue": "XjDl",
	"./Contact.vue": "9/A6",
	"./Features.vue": "gLNS",
	"./Features2.vue": "TLBc",
	"./HomePage.vue": "i2cO",
	"./HowItWorks.vue": "6e1g",
	"./Invite.vue": "4B3K",
	"./Join.vue": "fS8H",
	"./LandingPage.vue": "ILHl",
	"./Pricing.vue": "wa5P",
	"./Privacy.vue": "t8AH",
	"./Qr.vue": "ua/p",
	"./ResetPassword.vue": "r7EH",
	"./Setup.vue": "kSec",
	"./SignIn.vue": "npM1",
	"./SignUp.vue": "8uSK",
	"./StarterPack.vue": "MQyJ",
	"./Support.vue": "BT85",
	"./TOS.vue": "OKld",
	"./Welcome.vue": "l9ZU",
	"./oauth.vue": "pD6U"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XpeC";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/homepage ^\.\/\w+\.vue$
// module id = XpeC
// module chunks = 1